export default __webpack_public_path__ + "static/media/img1.24787d8a.svg";